import script from "./schemaInfo.vue?vue&type=script&lang=js"
export * from "./schemaInfo.vue?vue&type=script&lang=js"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/global/schemaInfo.vue'],['__file',"schemaInfo.vue"]])

export default __exports__